import { _ } from "../../../polyglot/polyglot.js";
import { plusIcon, trashAltIcon } from "../../../elements/icons/index.js";
import AbstractWidgetsListStrategy from "../../../widgets/WidgetsListWidget/strategies/AbstractWidgetsListStrategy.js";

/**
 * Strategy to render account intervals inside a WidgetsListWidget.
 * It acts on an array of strings representing account intervals, such as
 * "2323-3232"
 *
 * The validation here is that none interval must be blank.
 *
 * @param {string} inputCssClass - Additional css class to add to the input
 *   rendered for each item
 */
export default class AccountIntervalsStrategy extends AbstractWidgetsListStrategy {
	constructor({ inputCssClass }) {
		super(...arguments);

		this._inputCssClass = inputCssClass;
	}

	isInlined() {
		return true;
	}

	isValidatingOnChange() {
		return true;
	}

	itemRenderer({ item: value, index }) {
		return (html) =>
			html.div(
				{ class: "vat-account-input" },
				html.input({
					"data-test": "item",
					help: _('Enter an account interval. Example: "3010-3100"'),
					placeholder: "3010-3100",
					class: ["form-control", this._inputCssClass],
					type: "string",
					name: "interval",
					value: value.toString(),
					change: ({ target }) => {
						this._items[index] = target.value;
						this._triggerOnChange();
					},
				}),
			);
	}

	addButtonRenderer({ onClick }) {
		return (html) =>
			html.div(
				{
					class: "btn btn-default",
					click: onClick,
					"data-test": "add",
				},
				plusIcon,
			);
	}

	deleteButtonRenderer({ onClick }) {
		return (html) => {
			html.button(
				{
					class: "btn btn-xs delete-button",
					click: onClick,
					"data-test": "delete",
				},
				trashAltIcon,
			);
		};
	}

	_makeNewItem() {
		return "";
	}

	_validateItem({ item, collector }) {
		collector.addErrorIf(item === "", _("No input should be blank"));
	}
}
